import {SET_COMPS_ERROR, SET_COMPS_LOADED, SET_COMPS_LOADING} from 'constants/actionTypes'
import {ERROR, LOADED, LOADING, ReduxStateStatus, UNSET} from 'constants/reduxStatuses'
import type {ComposType} from 'types/propertyTypes'

type ComposState = {
  status: ReduxStateStatus
  data: {
    comps: ComposType[]
    subjectPid?: string
  }
  error?: null
}

type ComposAction =
  | {
      type: typeof SET_COMPS_ERROR
      payload: ComposState['error']
    }
  | {
      type: typeof SET_COMPS_LOADING
    }
  | {
      type: typeof SET_COMPS_LOADED
      payload: ComposState['data']
    }

const initialState: ComposState = {
  status: UNSET,
  data: {
    comps: []
  },
  error: null
}

export default function compsReducer(state = initialState, action: ComposAction): ComposState {
  const {type} = action

  switch (type) {
    case SET_COMPS_ERROR:
      return {
        ...state,
        status: ERROR,
        error: action.payload
      }
    case SET_COMPS_LOADING:
      return {
        ...state,
        status: LOADING
      }
    case SET_COMPS_LOADED:
      return {
        ...state,
        status: LOADED,
        data: action.payload,
        error: null
      }
    default:
      return state
  }
}
